// ロフトベッド: 上部にベッド、下に空間
import { Box } from '@react-three/drei'

export default function LoftBedMesh({ width, height, depth, position, color, isSelected }) {
    const bedHeight = height * 0.7
    const mattressThickness = height * 0.1
    const legThickness = width * 0.05
    const railHeight = height * 0.12
    const bedY = position[1] - height / 2 + bedHeight

    const legPositions = [
        [-width / 2 + legThickness / 2, position[1], -depth / 2 + legThickness / 2],
        [width / 2 - legThickness / 2, position[1], -depth / 2 + legThickness / 2],
        [-width / 2 + legThickness / 2, position[1], depth / 2 - legThickness / 2],
        [width / 2 - legThickness / 2, position[1], depth / 2 - legThickness / 2],
    ]

    return (
        <group>
            {/* 支柱 */}
            {legPositions.map((pos, i) => (
                <Box key={i} args={[legThickness, height, legThickness]} position={pos}>
                    <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
                </Box>
            ))}

            {/* ベッドフレーム */}
            <Box args={[width, height * 0.03, depth]} position={[0, bedY, 0]}>
                <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* マットレス */}
            <Box args={[width - 0.1, mattressThickness, depth - 0.1]} position={[0, bedY + height * 0.015 + mattressThickness / 2, 0]}>
                <meshStandardMaterial color={color} metalness={0.1} roughness={0.6} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 落下防止柵 */}
            <Box args={[width, railHeight, depth * 0.03]} position={[0, bedY + mattressThickness + railHeight / 2, -depth / 2 + depth * 0.015]}>
                <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* ワイヤーフレーム - 支柱 */}
            {legPositions.map((pos, i) => (
                <Box key={`wire-${i}`} args={[legThickness, height, legThickness]} position={pos}>
                    <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
                </Box>
            ))}

            {/* ワイヤーフレーム - ベッドフレーム */}
            <Box args={[width, height * 0.03, depth]} position={[0, bedY, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - マットレス */}
            <Box args={[width - 0.1, mattressThickness, depth - 0.1]} position={[0, bedY + height * 0.015 + mattressThickness / 2, 0]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* ワイヤーフレーム - 落下防止柵 */}
            <Box args={[width, railHeight, depth * 0.03]} position={[0, bedY + mattressThickness + railHeight / 2, -depth / 2 + depth * 0.015]}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* 選択時のハイライト */}
            {isSelected && (
                <Box args={[width, height, depth]} position={position}>
                    <meshBasicMaterial
                        color="#fbbf24"
                        wireframe
                        opacity={0.8}
                        transparent
                    />
                </Box>
            )}
        </group>
    )
}
